export default {
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload"
  },
  public:{
    audit: "audit",
    noPass: "No Pass",
    pass: "Pass",
    notAudit: "Unaudited"
  },
  wealth:{
    queryComment:'View comments',
    title:'Title',
    type:'Type',
    content:'Content',
    author:'Author',
    createTime: "Release Time",
    readRandomCount:'Virtual read count',
    readRealCount:'Real read count',
    readTotalCount:'Total read count',
    commentCount:'Number of comments',
    supportRandomCount:'Virtual Likes',
    supportRealCount:'Real number of likes',
    supportTotalCount:'Total number of likes',
    nickName: "Comment User",
    commentTime: "Comment Time",
    remark:"Message content",
    commentStatus: "Audit Status",
    copy:"Copy",
    audit: "audit",
    noPass: "No Pass",
    pass: "Pass",
    phone:"Mobile Number",
    addComment: "Add Comment",
    commentTotalCount: "Total number of comments",
    auditPassCount: "Number of reviews passed",
    auditNotPassCount: "Number of unpassed reviews",
    notAuditCount: "Number of unapproved comments",
    shortEssay: "Short Post",
    longEssay: "Long Essay",
    notAudit: "Unaudited"
  },
  topic:{
    notStart:"Haven’t started",
    start:" Started",
    over:"Finished",
    en_US:"English",
    vi_VN:"Vietnamese",
    titleName:"Topic name",
    startTime:"Start time",
    endTime:"Finish time",
    topicAbstract:"Topic summary",
    lang:"Language",
    productCode:" Setting quote( Separate with #)",
    voteView:"Vote points",
    supportCopy:"Word Supported ",
    supportCount:" Operation supporters ",
    oppositionCopy:"Word opposed",
    oppositionCount:"Operation objectors ",
    topicDetail:"Topic details",
    title:"Title",
    topicStatus:" State topic",
    supportCountReal:" Actual supporters",
    oppositionCountReal:"Actual objectors",
    commentCount:"Comments",
    viewMessage:"Read messages",
    batchAudit:"You have to choose at least one in “batch audit successfully",
    topicMessage:" Topic messages",
    export:"Export",
    batchUpdate:"Batch update",
    support:"Support",
    oppose:"Oppose",
    topic:"Topic",
    status:"State",
    opType:"Opinion",
    customerNo:"Account",
    createTime:"Publish time",
    likeCount:"Like numbers",
    commentContent:"Comment Content ",
    updateTime:"Update time",
    top:"Pinned",
    notTop:"Cancle pinned "
  },
  question:{
    addType:"Add a first-level category",
    name:"Course category",
    code:"coding",
    type:"Types of",
    decide:"True or False",
    radio:"radio",
    checkbox:"checkbox",
    question:"question",
    addOption:"New option",
    deleteOption:"Delete option",
    answer:"answer",
    parsing:"parsing",
  }
}
